import { render, staticRenderFns } from "./CasesCreated.vue?vue&type=template&id=10312dff&scoped=true&"
import script from "./CasesCreated.vue?vue&type=script&lang=js&"
export * from "./CasesCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10312dff",
  null
  
)

export default component.exports